import { createApi } from '@shared/redux/createApi';

const tags = {
  notifications: 'notifications',
  endpoints: 'endpoints'
};

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  tagTypes: Object.values(tags),
  endpoints: (builder) => ({
    getBlockedList: builder.query({
      query: () => ({
        url: '/admin/blocked-list',
        method: 'get'
      }),
      providesTags: [tags.notifications]
    }),
    getEndpointList: builder.query({
      query: () => ({
        url: '/role/endpoint/list',
        method: 'get'
      }),
      providesTags: [tags.endpoints]
    }),
    blockEndpoint: builder.mutation({
      query: ({ endpoint, description }) => ({
        url: '/admin/endpoint-block',
        method: 'post',
        body: { endpoint, description }
      }),
      invalidatesTags: [tags.notifications]
    }),
    unblockEndpoint: builder.mutation({
      query: (endpoint) => ({
        url: '/admin/endpoint-unblock',
        method: 'post',
        body: { endpoint }
      }),
      invalidatesTags: [tags.notifications]
    })
  })
});

export const {
  useGetBlockedListQuery,
  useGetEndpointListQuery,
  useBlockEndpointMutation,
  useUnblockEndpointMutation
} = notificationsApi;
